interface urlType {
    navUrl: string
}
const url: urlType = {
    // 导航栏配置
    navUrl:'api/webApi/index/navigation'
}
export default url